/**
 * Normalizes miscased query params before the router (`createBrowserHistory`) and the
 * rest of the app read them. Some callers pass `appInstanceConfigUUID`, but the whole
 * app reads `appInstanceConfigUuid`. Query params are case-sensitive, so without this the
 * uuid is dropped from the request and the app gets stuck on an infinite loading state.
 *
 * Must be imported FIRST in `index.tsx` so it runs before `history` snapshots the URL.
 */
const PARAM_ALIASES: ReadonlyArray<[legacy: string, canonical: string]> = [
  ['appInstanceConfigUUID', 'appInstanceConfigUuid'],
];

export const normalizeSearchParams = (): void => {
  const { search, pathname, hash } = window.location;

  let normalized = search;
  PARAM_ALIASES.forEach(([legacy, canonical]) => {
    if (normalized.includes(`${legacy}=`) && !normalized.includes(`${canonical}=`)) {
      normalized = normalized.replace(`${legacy}=`, `${canonical}=`);
    }
  });

  if (normalized !== search) {
    window.history.replaceState(null, '', `${pathname}${normalized}${hash}`);
  }
};

normalizeSearchParams();
